import { type Brand, make } from 'ts-brand';

/** Shape of the {@link User} model. */
type UserShape = Readonly<{

  /** Identifier. */
  id: string;

  /** First name. */
  firstName: string;

  /** Second name. */
  secondName: string;

  /** Date of birth. */
  dateOfBirth: Date;

  /** Age. */
  age: number;
}>;

/** User. */
export type User = Brand<UserShape, 'User'>;

/** User constructor. */
export const makeUser = make<User>();

/** Fields available for sorting the users. */
export type UserSortField = keyof UserShape;

/** All User fields for template usage if needed. */
export const USER_SORT_FIELDS: Record<UserSortField, UserSortField> = {
  id: 'id',
  firstName: 'firstName',
  secondName: 'secondName',
  dateOfBirth: 'dateOfBirth',
  age: 'age',
} as const;
